<template>
  <v-container>
    <v-dialog v-model="dialog_value.show" max-width="700px" @click:outside="$store.commit('close_edit_cast_dialog_admin')">
      <v-card>
        <v-toolbar flat color="primary" dark class="justify-center">
          <v-toolbar-title>اصلاح اطلاعات فرد</v-toolbar-title>
        </v-toolbar>
        <validation-observer v-slot="{ valid }">
          <v-card-text>
            <Cast :cast="dialog_value.user"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" outlined @click="$store.commit('close_edit_cast_dialog_admin')">
              لغو
            </v-btn>
            <v-btn color="secondary" :disabled="!valid" @click="$store.dispatch('update_cast_admin' , {id : dialog_value.user.id})" >
              ویرایش
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import {mapState} from "vuex";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import static_config from "../../common/Statics";
import {digits, numeric, required} from "vee-validate/dist/rules";
import Cast from "@/components/submit/steps/Cast";

extend('phone_number', {
  validate: value => {
    return value.length === 11 && /^09[0-9]{9}$/.test(value);
  },
  message: 'شماره تلفن همراه باید 11 رقمی باشد.'
});

extend("required", {
  ...required,
  message: "پر کردن این قسمت اجباریست",
});

extend("digits", {
  ...digits,
  message: "کد ملی وارد شده صحیح نمیباشد",
});

extend("numeric", {
  ...numeric,
  message: "لطفا سن درست را وارد کنید",
});
extend("fixed_phone", {
  ...numeric,
  message: "تلفن وارد شده صحیح نمیباشد",
});

export default {
  name: "EditCastDialogAdmin",
  components: {
    Cast,
    ValidationProvider,
    ValidationObserver
  },
  data: () => {
    return {
      months: static_config.months,
      genders: static_config.genders,
      school_type: static_config.school_type,
      states: static_config.states_cities(),
    }
  },
  computed: {
    ...mapState({
      dialog_value: state => state.Admin.settings.edit_cast_dialog
    }),
    years: () => {
      let y = [];
      for (let i = 1360; i <= 1396; i++) {
        y.push(i);
      }
      return y;
    },
    days: () => {
      let y = [];
      for (let i = 1; i <= 30; i++) {
        y.push(i);
      }
      return y;
    },
  },

}
</script>

<style scoped>

</style>